import { IconProps } from '../../atoms/Icon';
import { TextProps } from '../../atoms/Text';


type DropDownItemInternalProps = {
  icon?: IconProps;
  text?: TextProps;
};

type DropDownItemPropsValues = {
  'CriticalIconTextUnselected': DropDownItemInternalProps;
  'DefaultIconTextSelected': DropDownItemInternalProps;
  'DefaultIconTextUnselected': DropDownItemInternalProps;
  'DefaultTextSelected': DropDownItemInternalProps;
  'DefaultTextUnselected': DropDownItemInternalProps;
  'DefaultTextIconSelected': DropDownItemInternalProps; // MANUAL OVERRIDE
  'DefaultTextIconUnselected': DropDownItemInternalProps; // MANUAL OVERRIDE
};

const propValues: DropDownItemPropsValues = {
  'CriticalIconTextUnselected': {
    icon: {
      asset: 'Plus',
      colour: 'IconDark',
    },
    text: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading5',
    },
  },
  'DefaultIconTextSelected': {
    icon: {
      asset: 'SelectedFilled',
      colour: 'IconSubdued',
    },
    text: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading5',
    },
  },
  'DefaultIconTextUnselected': {
    icon: {
      asset: 'SelectedFilled',
      colour: 'IconSubdued',
    },
    text: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading5',
    },
  },
  'DefaultTextSelected': {
    text: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading5',
    },
  },
  'DefaultTextUnselected': {
    text: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading5',
    },
  },
  'DefaultTextIconSelected': { // MANUAL OVERRIDE
    text: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading5',
    },
    icon: {
      asset: 'SelectedFilled',
      colour: 'IconSubdued',
    },
  },
  'DefaultTextIconUnselected': { // MANUAL OVERRIDE
    text: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading5',
    },
  },
};

const getProps = (type: string): DropDownItemInternalProps => {
  const values: DropDownItemInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
